// extracted by mini-css-extract-plugin
export default {"userIcon":"user-button_userIcon__rmmGQ"};